
export default {
  name: 'AppReviewEvaluationTypeOptions',
  props: {
    options: {
      type: Array,
      required: true
    }
  }
};
